/* Optional additions: no offer is ever preselected. */
if (!customElements.get('auren-upsells')) {
  customElements.define('auren-upsells', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => {
        const card = event.target.closest('[data-upsell-card]');
        if (!card) return;
        // These selectors are not cart quantity fields; Dawn listens to bubbled changes.
        event.stopPropagation();
        const option = card.querySelector('select').selectedOptions[0];
        card.querySelector('[data-upsell-price]').textContent = option.dataset.money;
        const image = card.querySelector('img');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
        this.dispatchEvent(new CustomEvent('auren:upsell-change', { bubbles: true }));
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-upsell-add]');
        if (button) this.addOffer(button);
      });
    }
    selectedItems() {
      return [...this.querySelectorAll('[data-upsell-check]:checked')].map(input => {
        const option = input.closest('[data-upsell-card]').querySelector('select').selectedOptions[0];
        return { id: Number(option.value), quantity: 1, price: Number(option.dataset.price) };
      });
    }
    async addOffer(button) {
      if (this.busy) return;
      this.busy = true;
      const option = button.closest('[data-upsell-card]').querySelector('select').selectedOptions[0];
      const error = this.querySelector('[data-upsell-error]');
      const cart = document.querySelector('cart-drawer');
      const items = [{ id: Number(option.value), quantity: 1 }];
      const payload = { items, sections_url: location.pathname };
      if (cart?.getSectionsToRender) payload.sections = cart.getSectionsToRender().map(s => s.id);
      this.querySelectorAll('button,select').forEach(el => el.disabled = true);
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || window.aurenStrings?.add_error);
        if (cart && payload.sections.every(id => typeof data.sections?.[id] === 'string')) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auren-upsell', cartData: data });
      } catch (exception) {
        error.textContent = exception.message || window.aurenStrings?.add_error || 'Please try again.';
        error.hidden = false;
      } finally {
        this.busy = false;
        this.querySelectorAll('button,select').forEach(el => el.disabled = false);
        button.removeAttribute('aria-busy');
      }
    }
  });
}

if (!customElements.get('auren-media-slider')) {
  customElements.define('auren-media-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-media-track]');
      this.slides = [...this.querySelectorAll('[data-media-slide]')];
      this.index = 0;
      const move = delta => this.track.scrollTo({ left: this.slides[Math.max(0, Math.min(this.slides.length - 1, this.index + delta))].offsetLeft - this.slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.querySelector('[data-media-prev]')?.addEventListener('click', () => move(-1), { signal });
      this.querySelector('[data-media-next]')?.addEventListener('click', () => move(1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.update = () => {
        const x = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - x) < Math.abs(this.slides[best].getBoundingClientRect().left - x) ? i : best, 0);
        this.querySelector('[data-media-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
        this.querySelector('[data-media-prev]').disabled = this.index === 0;
        this.querySelector('[data-media-next]').disabled = this.index === this.slides.length - 1;
        this.slides.forEach((slide, i) => { if (i !== this.index) slide.querySelector('video')?.pause(); });
      };
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); }, { signal });
      this.visibility = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.querySelectorAll('video').forEach(video => video.pause()); });
      this.visibility.observe(this);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.visibility?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}
